module.exports = __webpack_public_path__ + "img/autocolant-test.81a33e27.png";